import { useQuery } from "@tanstack/react-query";

import { flowsApi } from "src/api/endpoints";
import { FlowWithMatchingVersions } from "src/clients/flow-api";

const FLOW_REFERENCES_KEY = "flow-references";

const fetchFlowsDependingOnAgent = async (
  workspaceId: string,
  agentId: string,
  status: string,
): Promise<FlowWithMatchingVersions[]> => {
  const response =
    await flowsApi.getFlowsDependingOnAgentApiV1FlowsDependingOnWorkspaceWorkspaceIdAgentAgentIdGet(
      workspaceId,
      agentId,
      status,
    );
  return response.data;
};

const fetchFlowsDependingOnAgentVersion = async (
  workspaceId: string,
  agentId: string,
  agentVersionId: string,
  status: string,
): Promise<FlowWithMatchingVersions[]> => {
  const response =
    await flowsApi.getFlowsDependingOnAgentVersionApiV1FlowsDependingOnWorkspaceWorkspaceIdAgentAgentIdVersionAgentVersionIdGet(
      workspaceId,
      agentId,
      agentVersionId,
      status,
    );
  return response.data;
};

export const usePublishedFlowsReferencingAgent = (
  workspaceId: string,
  agentId: string,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [FLOW_REFERENCES_KEY, "agent", "PUBLISHED", workspaceId, agentId],
    queryFn: () =>
      fetchFlowsDependingOnAgent(workspaceId, agentId, "PUBLISHED"),
    enabled: options?.enabled,
  });

export const useDraftFlowsReferencingAgent = (
  workspaceId: string,
  agentId: string,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [FLOW_REFERENCES_KEY, "agent", "DRAFT", workspaceId, agentId],
    queryFn: () => fetchFlowsDependingOnAgent(workspaceId, agentId, "DRAFT"),
    enabled: options?.enabled,
  });

export const usePublishedFlowsReferencingAgentVersion = (
  workspaceId: string,
  agentId: string,
  agentVersionId: string,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [
      FLOW_REFERENCES_KEY,
      "agentVersion",
      "PUBLISHED",
      workspaceId,
      agentId,
      agentVersionId,
    ],
    queryFn: () =>
      fetchFlowsDependingOnAgentVersion(
        workspaceId,
        agentId,
        agentVersionId,
        "PUBLISHED",
      ),
    enabled: options?.enabled,
  });

export const useDraftFlowsReferencingAgentVersion = (
  workspaceId: string,
  agentId: string,
  agentVersionId: string,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [
      FLOW_REFERENCES_KEY,
      "agentVersion",
      "DRAFT",
      workspaceId,
      agentId,
      agentVersionId,
    ],
    queryFn: () =>
      fetchFlowsDependingOnAgentVersion(
        workspaceId,
        agentId,
        agentVersionId,
        "DRAFT",
      ),
    enabled: options?.enabled,
  });
